import { Chip, Grid } from '@material-ui/core';
import { DateRangeRounded, DescriptionRounded, DoneRounded, EmailRounded, HomeWorkRounded, PhoneRounded, ScheduleRounded, SchoolRounded, WorkRounded } from '@material-ui/icons';
import { useStyles } from '@webapps/styles';
import { formatDate224 } from '@webapps/utils';
import { formatPhoneNumber } from 'react-phone-number-input';

const SchoolInfo = ({ opcoRecord, dataCompletion }) => {
  const { classes, css, cx, global } = useStyles(styles);

  return (
    <div className={cx(global.fcjs, css({ gap: 24 }))}>
      <div className={cx(global.title, global.blueBar)}>Organisme de formation</div>
      <Grid container spacing={1}>
        <Grid item xs={6} className={cx(global.fcjs, css({ gap: 4 }))}>
          <div className={cx(global.infoText, classes.overviewText)}>
            <HomeWorkRounded className={global.infoIcon} style={{ color: "#0060F9" }} />
            <div><span style={{ fontWeight: 600 }}>Organisme de formation : </span>{opcoRecord?.training?.school?.name}</div>
          </div>
          <div className={cx(global.infoText, classes.overviewText)}>
            <WorkRounded className={global.infoIcon} style={{ color: "#0060F9" }} />
            <div><span style={{ fontWeight: 600 }}>Formation : </span>{opcoRecord?.training?.label}</div>
          </div>
          <div className={cx(global.infoText, classes.overviewText)}>
            <SchoolRounded className={global.infoIcon} style={{ color: "#0060F9" }} />
            <div><span style={{ fontWeight: 600 }}>Niveau de diplôme : </span>{opcoRecord?.training?.degree?.label}</div>
          </div>
          <div className={cx(global.infoText, classes.overviewText)}>
            <DescriptionRounded className={global.infoIcon} style={{ color: "#0060F9" }} />
            <div><span style={{ fontWeight: 600 }}>Type de formation : </span>{opcoRecord?.training?.trainingType?.label}</div>
          </div>
          <div className={cx(global.infoText, classes.overviewText)}>
            <DateRangeRounded className={global.infoIcon} style={{ color: "#0060F9" }} />
            <div><span style={{ fontWeight: 600 }}>Dates de formation : </span>{`${formatDate224(opcoRecord?.training?.openingDate)} au ${formatDate224(opcoRecord?.training?.closingDate)}`}</div>
          </div> 
          <div className={cx(global.infoText, classes.overviewText)}>
            <EmailRounded className={global.infoIcon} style={{ color: "#0060F9" }} />
            <div><span style={{ fontWeight: 600 }}>Adresse email : </span>{opcoRecord?.training?.school?.email || 'Non renseigné'}</div>
          </div>
          <div className={cx(global.infoText, classes.overviewText)}>
            <PhoneRounded className={global.infoIcon} style={{ color: "#0060F9" }} />
            <div><span style={{ fontWeight: 600 }}>Téléphone : </span>{opcoRecord?.training?.school?.phone ? formatPhoneNumber(opcoRecord?.training?.school?.phone) : 'Non renseigné'}</div>
          </div>
        </Grid>
        <Grid item xs={6} className={cx(global.fcjs, css({ gap: 4 }))}>
          <Chip 
            className={cx(global.chipValid, global.fracjs)} 
            label={
            <div className={cx(global.frac, css({gap: 12}))}><DoneRounded style={{ fontSize: 20 }} /> <div>Inscrit sur Linkpick</div></div>
            } 
            size="medium" 
          />
          <Chip 
            className={cx(dataCompletion ? global.chipPending : global.chipValid, global.fracjs)} 
            label={
            <div className={cx(global.frac, css({gap: 12}))}>
              {dataCompletion ? (
                <>
                  <ScheduleRounded style={{ fontSize: 20 }} /> <div>Complétion des données</div>
                </>
              ) : (
                <>
                  <DoneRounded style={{ fontSize: 20 }} /> <div>Données complètes</div>
                </>
              )}
            </div>
            } 
            size="medium" 
          />
          <Chip 
           className={cx(
            opcoRecord?.contract 
              ? opcoRecord?.contract?.cfaSignAction !== "SIGNED" || opcoRecord?.contract?.status === "OUTDATED"
                ? global.chipAction 
                : global.chipValid 
              : global.chipDisabled, 
              global.fracjs
            )}            
            label={
            <div className={cx(global.frac, css({gap: 12}))}>
              {opcoRecord?.contract?.cfaSignAction != "SIGNED" ? (
                <>
                  <ScheduleRounded style={{ fontSize: 20 }} /> <div>Signatures en attente</div>
                </>
              ) : opcoRecord?.contract?.status === "OUTDATED" ? (
                <>
                  <ScheduleRounded style={{ fontSize: 20 }} /> <div>Contrat et convention obsolètes</div>
                </>
              ) : (
                <>
                  <DoneRounded style={{ fontSize: 20 }} /> <div>Contrat et convention signés</div>
                </>
              )}
            </div>
            } 
            size="medium" 
          />
        </Grid>
      </Grid>
    </div>
  );
};

const styles = () => ({
 overviewText: {
  color: "#152652",
  display: 'flex',
  alignItems: 'center',
 },
});

export default SchoolInfo;